import { render, staticRenderFns } from "./StandardSizeSelector.vue?vue&type=template&id=2ed43ecc&lang=pug"
import script from "./StandardSizeSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./StandardSizeSelector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports